import colors from '../theme/colors';

const styles = {
  login: {
    fontFamily: 'RooneySans',
    backgroundColor: { xs: colors.background.paper, sm: '#2d3b47' },
    minHeight: '100vh',
    paddingTop: { xs: '40px', sm: '0' },
    back: {
      fontFamily: 'RooneySans',
      '& .back-button': {
        borderRadius: '50%',
        border: `1px solid ${colors.primary.main}`,
        '& svg': {
          color: colors.primary.main,
        },
      },
    },
    form: {
      fontFamily: 'RooneySans',
      width: '100%',
      maxWidth: '440px',
      margin: '0 auto',
      padding: '20px 40px',
      borderRadius: '8px',
      border: { xs: 0, sm: '1px solid #ccc' },
      backgroundColor: colors.background.paper,
      submit: {
        fontFamily: 'RooneySans',
        backgroundColor: colors.primary.main,
        color: colors.background.paper,
        textTransform: 'none',
        padding: '10px 30px',
        height: '40px',
        margin: '0 auto',
        borderRadius: '20px',
        fontSize: '19px',
        width: { xs: '100%', sm: 'auto' },
        '&:hover': {
          backgroundColor: colors.primary.main,
        },
      },
      label: {
        fontFamily: 'RooneySans',
        left: '-14px',
        color: '#08202A',
        fontWeight: 600,
      },
      muiInput: {
        fontFamily: 'RooneySans',
        mb: 1.5,
        mt: 1,
        '& .Mui-error': {
          marginLeft: '0',
        },
        input: {
          fontFamily: 'RooneySans',
          fontSize: '16px',
          padding: '10px 14px',
        },
      },
    },
    title: {
      fontFamily: 'RooneySans',
      fontSize: '22px',
      fontWeight: 600,
      color: colors.primary.main,
      margin: '0 0 8px 0',
    },
    subtitle: {
      fontFamily: 'RooneySans',
      fontSize: '16px',
      fontWeight: 600,
      margin: '0 0 10px 0',
    },
    forgot: {
      fontFamily: 'RooneySans',
      color: colors.primary.main,
      fontSize: '14px',
      fontWeight: 400,
      marginTop: '-30px',
      cursor: 'pointer',
      zIndex: 1,
    },
    signup: {
      fontFamily: 'RooneySans',
      color: colors.primary.main,
      fontSize: '14px',
      fontWeight: 400,
      cursor: 'pointer',
    },
  },
};

export default styles;
